import { Label, Layout } from "@mcleod/components";

export abstract class AutogenLayoutPNNUnsubscribe extends Layout {
    labelResponse: Label;
}
